// API 配置文件
const API_CONFIG = {
  // 基础配置
  BASE_URL: process.env.VUE_APP_BASE_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:9000'),
  API_BASE_URL: process.env.VUE_APP_API_BASE_URL || (process.env.NODE_ENV === 'production' ? '/sehome/api' : 'http://localhost:9000/sehome/api'),
  WEBSOCKET_URL: process.env.VUE_APP_API_BASE_URL?.replace('/api', '') || (process.env.NODE_ENV === 'production' ? '/sehome' : 'http://localhost:9000/sehome'),
  
  // 获取完整的API URL
  getApiUrl: (path = '') => {
    const baseUrl = API_CONFIG.API_BASE_URL
    return path ? `${baseUrl}${path.startsWith('/') ? path : '/' + path}` : baseUrl
  },
  
  // 获取完整的基础URL
  getBaseUrl: (path = '') => {
    const baseUrl = API_CONFIG.BASE_URL
    return path ? `${baseUrl}${path.startsWith('/') ? path : '/' + path}` : baseUrl
  },
  
  // SSE功能已移除，改为HTTP轮询
  // getSSEUrl 方法已废弃
  
  // 处理图片URL
  getImageUrl: (imagePath) => {
    if (!imagePath) return ''
    
    // 如果已经是完整URL，直接返回
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
      // 修复localhost:8080的情况
      if (imagePath.includes('localhost:8080')) {
        return imagePath.replace('http://localhost:8080/', API_CONFIG.getBaseUrl('/'))
      }
      return imagePath
    }
    
    // 相对路径，添加基础URL
    return API_CONFIG.getBaseUrl(imagePath)
  }
}

export default API_CONFIG